/**
 * PreviewCard — framed preview surface for diagrams, media, or compact
 * artifact summaries in demo sidebars.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import { GRAY, PRIMARY } from "../design-system/tokens.js";

export interface PreviewCardProps {
  readonly title: string;
  readonly eyebrow?: string;
  readonly description?: string;
  readonly children: React.ReactNode;
}

export function PreviewCard({
  title,
  eyebrow,
  description,
  children,
}: PreviewCardProps): React.JSX.Element {
  return (
    <section
      style={{
        background: "white",
        border: `1px solid ${GRAY[300]}`,
        borderRadius: 8,
        display: "grid",
        gap: 9,
        padding: 10,
      }}
    >
      <header style={{ display: "grid", gap: 2 }}>
        {eyebrow !== undefined ? (
          <span
            style={{
              color: PRIMARY[700],
              fontSize: 10,
              fontWeight: 900,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            {eyebrow}
          </span>
        ) : null}
        <h3 style={{ color: GRAY[900], fontSize: 12, fontWeight: 800, margin: 0 }}>{title}</h3>
      </header>
      <div>{children}</div>
      {description !== undefined ? (
        <p style={{ color: GRAY[600], fontSize: 11, lineHeight: 1.45, margin: 0 }}>{description}</p>
      ) : null}
    </section>
  );
}
